<style lang="scss" scoped>
	@import "./subscriptonnew.css";
</style>
<style>
  *, *::before, *::after{
      font-family: 'element-icons';

  }
  .confirmbtn{
      color: #FFFFFF !important;
      background-color: #09666e!important;
      border-color: #09666e!important;
  }
  .el-button--small:hover{
      background-color: #ffffff ;
      border-color: #dcdfe6 ;
      color: #000;
  }
</style>
<style lang='scss'>
	#subscriptonnew {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
<template>
	<div id="subscriptonnew">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
				<a-row style="display: flex;align-items: center;">
					<a-col :xl="{ span: 24 }">
						<a-row>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="信息查詢" class="formItem">
									<a-input v-model="params.searchstr" placeholder="請輸入股票名稱/股票代碼"  :allowClear="true" @change="handleClear(3)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<!-- <a-col :xl="{ span: 4 }">
								<a-form-model-item label="股票名稱" class="formItem">
									<a-input v-model="params.stockname" placeholder="請輸入股票名稱"  :allowClear="true" @change="handleClear(1)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 4 }">
								<a-form-model-item label="股票代碼" class="formItem">
									<a-input v-model="params.stockcode" placeholder="請輸入股票代碼"  :allowClear="true" @change="handleClear(2)"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col> -->
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="上市狀態" class="formItem">
									<a-select v-model="params.status_cn" placeholder="請選擇上市狀態" @change="searchEvent">
										<a-select-option v-for="(item) in admintypeArr" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="上市版塊" class="formItem">
									<a-select v-model="params.plates_cn" placeholder="請選擇上市版本">
										<a-select-option v-for="(item) in admintypeArrs" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="保薦機構" class="formItem">
									<!-- <a-select v-model="params.baojianr" placeholder="請選擇保衛脊膘">
										<a-select-option v-for="(item) in khtypeArrbj" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select> -->
									<Situationall v-model="params.baojianr" :url='$api.getParamList'
										:params='{"type":"baojianr"}' :style='"width:100%"' :placeholder="'請選擇保薦機構'">
									</Situationall>
									<!-- <a-input v-model="params.baojianr" placeholder="請輸入保衛脊膘" /> -->
								</a-form-model-item>
							</a-col>
							<div style="width: 100%;height: 3rem;"></div>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="上市行業" class="formItem">
									<!-- <a-select v-model="params.cn_planned_industry_name_cn" placeholder="請選擇上市行業">
										<a-select-option v-for="(item) in khtypeArrs" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select> -->
									<Situationall v-model="params.cn_planned_industry_name_cn" :url='$api.getParamList' :route1="routeFlag"
										:params='{"type":"industrys"}' :style='"width:100%"' :placeholder="'請選擇上市行業'">
									</Situationall>
									<!-- <a-input v-model="params.cn_planned_industry_name_cn" placeholder="請輸入上市行業" /> -->
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="設置狀態" class="formItem">
									<a-select v-model="params.hot_status" placeholder="請選擇設置狀態">
										<a-select-option v-for="(item) in khtypeArr" :key="item.key"
											:value="item.value">{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="認購日期" class="formItem">
									<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 1 }"></a-col>
							<a-col :xl="{ span: 5 }"
								style="display: inline-flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" @click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:#ffa647;" @click='isopen = true'>
					<img src="../../image/icon_tianjia.png" class="btnIcon" />
					<span>添加</span>
				</a-button>
				<a-button v-if='ipoAduitAdmin' class="bottomBtn" style="background-color:#ed4849;" @click="handDelect">
					<img src="../../image/icon_shanchu.png" class="btnIcon" />
					<span>刪除</span>
				</a-button>
				<a-button class="bottomBtn" style="background-color:#3bc7a1;" @click="upClick()" v-if='ipoAduitAdmin'>
					<img src="../../image/icon_word.png" class="btnIcon"/>
					<span>導出</span>
				</a-button>
				<a-upload name="file" :data='{token:$store.state.token}' :headers='{token:$store.state.token}'
					class="avatar-uploader" :show-upload-list="false" :action="$api.importHongKongStocksExcel"
					:before-upload="beforeUpload" @change="handleChange">
					<a-button v-if='ipoAdmin' class="bottomBtn" style="background-color:rgb(88, 133, 234);">
						<img src="../../image/icon_daochu.png" class="btnIcon" />
						<span>導入</span>
					</a-button>
				</a-upload>
				<a-button v-if='ipoAduitAdmin&&params.missionflag>0' class="bottomBtn" style="background-color:#a06bf1;" @click="handipo">
					<img src="../../image/handall.png" class="btnIcon" />
					<span>批量審核</span>
				</a-button>
				<task :params='params' @child='fandfn'></task>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<span slot='alltext' style="font-size: 0.85rem;position: relative;left: -2.8rem;"></span>
				<span slot='stockname1' style="font-size: 0.85rem;position: relative;right: -2rem;">股票名稱</span>
				<!-- :scroll="{ y: 'calc(100vh - 430px)', x: '100vw'}" -->
				<div slot='hot_status' slot-scope="record" style="white-space: nowrap;" :title='record.stockname'>
					<div v-if='record.hot_status == 1' style='display: inline-block;margin-right: 5px;'><img :src="icon_fasong" alt="" style='width: 1rem;'></div>
					<div v-if='record.hot_status == 2' style='display: inline-block;margin-right: 5px;'><img :src="icon_hot" alt="" style='width: 1rem;'></div>
					<div style='display: inline-block;'>
						{{record.stockname}}
					</div>
				</div>
				<!-- 显示状态 -->
				<div slot="schedule" slot-scope="record">
					<div class="tableRowView1">
						<img :src="record.schedule > 0||record.handle == 1 ? icon_one : icon_one1" alt=""
							class="imageC">
						<div class="lineC"
							:style="!(record.schedule == 1&&record.handle == 2)&&(record.schedule > 0||record.handle == 1)? 'background:#467fff;' : ''">
							<span v-if="record.schedule <= 1&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 1||(record.schedule == 1&&record.handle == 1) ? icon_two : icon_two1"
							alt="" class="imageC">
						<!-- <div class="lineC"
							:style="!(record.schedule == 2&&record.handle == 2)&&(record.schedule > 1||(record.schedule == 1&&record.handle == 1)) ? 'background:#6cce68;' : ''">
							<span v-if="record.schedule == 2&&record.handle == 2" class="redX">x</span>
						</div>
						<img :src="record.schedule > 2 ||(record.schedule == 2&&record.handle == 1)? icon_three : icon_three1"
							alt="" class="imageC"> -->
							
							
							
						<!-- <div class="lineC" :style="!(record.schedule == 3&&record.handle == 2)&&record.schedule > 2 ||
						(record.schedule == 3&&record.handle == 0) ? 'background:#f7d429;' : ''">
							<span v-if="record.schedule == 3&&record.handle == 2" class="redX">x</span></div>
						<img :src="record.schedule > 3 ||(record.schedule == 3&&record.handle == 1) ? icon_four : icon_four1"
							alt="" class="imageC"> -->
					</div>
				</div>
				<!-- 控制按鈕 -->
				<div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div class="popoverView">
							<!-- <metemail :ipoAdmin='ipoAdmin' :record='record' 
								:missionflag='params.missionflag'  @child='handclose'>
							</metemail> -->
							<img :src="record.visible_bold ? icon_pdf1 : icon_pdf"
								class="imageC" @click='island = true;itemdata=record;record.visible_bold=true'>
						</div>
						<div class="popoverView">
							<img :src="record.shShowBol ? icon_bianji1 : icon_bianji" class="imageC" 
							 @click='isshShowBol = true;itemdata=record;record.shShowBol=true'>
							<!-- <ediotable :record='record' @child='handclose'></ediotable> -->
						</div>
						<div class="popoverView popoverView3">
							<pushbtn :record='record' @child='handclose' :params='params'></pushbtn>
						</div>
					</div>
				</div>
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
					<!-- <img @click.stop="downLoad()" src="../../image/icon_xiazai1.png"> -->
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<handhome v-if='isopen||island' :isopen='isopen' @child='handclose' :record='itemdata' :missionflag='params.missionflag'></handhome>
		<!-- <handItem v-if='isopen' :isopen='isopen' @child='handclose' ></handItem> -->
		<shenhe v-if='isshShowBol' :island='isshShowBol' @child='handclose' :record='itemdata'></shenhe>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
		<!-- <handItems v-if='(ipoAdmin||ipoAdmin3)&&island'  :island='island' @child='handclose'  :record='itemdata' :missionflag='params.missionflag'></handItems>
	<handlook v-else-if='island' :island='island'
		@child='handclose' :record='itemdata' :missionflag='params.missionflag'></handlook> -->
	</div>
</template>

<script>
	import exportData from "./components/exportData";
	import handhome from './comhome/handhome.vue'
	import https from '@/plugins/http.js';
	import apiUrl from '@/assets/api.js';
	import handItem from './components/handItem.vue'
	import shenhe from './components/shenhe.vue'
	import handItems from './components/handItems.vue'
	import handlook from './components/handlook.vue'
	import App from '@/assets/app.js';
	import icon_pdf from '@/image/icon_xiangqing.png';
	import icon_pdf1 from '@/image/icon_xiangqing_1.png';
	import icon_one from '../../image/subscr/bianji.png';
	import icon_one1 from '../../image/subscr/bianji2.png';
	import icon_two from '../../image/subscr/shenhe.png';
	import icon_two1 from '../../image/subscr/bianji1.png';
	import icon_three from '../../image/subscr/mazhan.png';
	import icon_three1 from '../../image/subscr/mazhan1.png';
	import icon_four from '../../image/icon_4.png';
	import icon_four1 from '../../image/icon_4_1.png';
	import wj_dlsfzOff from '../../image/wj_dlsfzOff.png';
	import icon_bianji from '@/image/icon_mess_1.png';
	import icon_bianji1 from '@/image/icon_mess.png';
	import wj_dz from '../../image/wj_dz.png';
	import wj_hkd from '../../image/wj_hkd.png';
	import wj_hksfzOff from '../../image/wj_hksfzOff.png';
	import wj_hz from '../../image/wj_hz.png';
	import wj_sfzOn from '../../image/wj_sfzOn.png';
	import wj_wgsfzOff from '../../image/wj_wgsfzOff.png';
	import wj_txz from '../../image/wj_txz.png';
	import {
		saveFileToLink
	} from 'web-downloadfile';

	import metemail from './components/metemail'
	import pushbtn from './components/pushbtn.vue'
	import ediotable from './components/ediotable.vue'
	import task from './components/task.vue'
	export default {
		components: {
			handhome,
			handItem,
			pushbtn,
			ediotable,
			metemail,
			exportData,
			task,handItems,shenhe,handlook
		},
		data() {
			return {
				upFlag:false,
				ishandout: false,
				allurl: '',
				pdfShow: false,
				pdfBolUrl: '',
				isdate:'',
				visible_bold:'',

				routeFlag:'hk_shangshi',
				ishandout:false,
				icon_bianji,
				icon_bianji1,
				icon_pdf,
				icon_pdf1,
				island:false,
				isshShowBol:false,
				itemdata:{},
				isopen: false,
				icon_fasong: require('@/image/icon_fasong.png'),
				icon_hot: require('@/image/icon_hot.png'),
				icon_one,
				icon_one1,
				icon_two,
				icon_two1,
				icon_three,
				icon_three1,
				icon_four,
				icon_four1,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限     审批管理员 ipoAduitAdmin 审批权限
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				ipoAduitAdmin: this.$store.state.rolesdata.indexOf('ipoAduitAdmin') >= 0,
				// ipoAdmin3 比 之前的權限 ipoAdmin 多出三個字符轉編輯權限
				ipoAdmin3: this.$store.state.rolesdata.indexOf('ipoAdmin3') >= 0,
				admintypeArr: [{
						text: '全部',
						value: ''
					},{
						text: '處理中',
						value: '0'
					},
					{
						text: '認購中',
						value: '1'
					},
					{
						text: '待上市',
						value: '2'
					},
					{
						text: '已上市',
						value: '3'
					},
					{
						text: '已除牌',
						value: '4'
					},
					{
						text: '已失效',
						value: '5'
					},					
				],
				admintypeArrs: [{
						text: '主板',
						value: '0'
					},
					{
						text: '創業板',
						value: '1'
					},
				],
				khtypeArr: [{
						text: '全部',
						value: ''
					},
					{
						text: '推送',
						value: 1
					},
					{
						text: '熱門',
						value: 2
					},
				],
				khtypeArrs: [],
				tzPageNum: '',
				columns: [
					// {
						// title: '',
						// dataIndex: '',
						// align: 'right',
						// width: '3%',
						// slots: {
						// 	title: 'alltext'
						// },
						// scopedSlots: {
						// 	customRender: 'hot_status'
						// }
					// },
					{
						// title: '股票名稱',
						dataIndex: '',
						align: 'left',
						width: '10%',
						slots: {
							title: 'stockname1'
						},
						scopedSlots: {
							customRender: 'hot_status'
						},
					},
					{
						title: '股票代碼',
						dataIndex: 'stockcode',
						align: 'center',
						width: '12%'
					},
					{
						title: '更新時間',
						dataIndex: 'createdate',
						align: 'center',
						width: '12%'
					},
					{
						title: '操作人員',
						dataIndex: 'realname',
						align: 'center',
						width: '12%'
					},
					{
						title: '上市狀態',
						dataIndex: 'status_cn',
						align: 'center',
						width: '12%'
					},
					{
						title: '審批進度',
						dataIndex: '',
						align: 'center',
						width: '15%',
						scopedSlots: {
							customRender: 'schedule'
						}
					},
					{
						title: '審批時間',
						dataIndex: 'processdate',
						align: 'center',
						width: '12%'
					},
					{
						title: '操作',
						dataIndex: '',
						align: 'center',
						width: 'auto',
						scopedSlots: {
							customRender: 'toolArr'
						}
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				khtypeArrbj: [],
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					hot_status: '',
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					applicationdate_begin: '', //認購起始日期
					applicationdate_end: '', //認購截止日期
					timeDate: [],
					missionflag: 0
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
			// this.handland("industrys")
			// this.handland("baojianr")
		},
		methods: {
			upClick(){
				this.upFlag = true
			},
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			pdfEvent(pxfs){
				let str = this.$api.pdfs; //getUnsk
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.exportHongKongStockPDF;
				// url += '?m=' + Date.parse(new Date())
				url += '?token=' + this.$store.state.token + '&m=' + Date.parse(new Date()) 
					+ '&searchstr=' + this.params.searchstr
					+ '&status_cn=' + this.params.status_cn
					+ '&sort=' + sort
					+ '&plates_cn=' + this.params.plates_cn
					+ '&baojianr=' + this.params.baojianr
					+ '&cn_planned_industry_name_cn=' + this.params.cn_planned_industry_name_cn
					+ '&hot_status=' + this.params.hot_status
					+ '&applicationdate_begin=' + this.params.applicationdate_begin
					+ '&applicationdate_end=' + this.params.applicationdate_end
				this.allurl = str + url
				console.log(url)
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});
							
				setTimeout(() => {
					this.pdfShow = true;
					console.log(this.pdfShow)
				}, 500);
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
			// 表格导出下载
			queryData(pxfs){
				let sort =  pxfs == undefined ? '' : pxfs
				let url = this.$api.exportHongHongStockExcel
				url += '?token=' + this.$store.state.token 
					+ '&m=' + Date.parse(new Date()) 
					+ '&searchstr=' + this.params.searchstr
					+ '&status_cn=' + this.params.status_cn
					+ '&sort=' + sort
					+ '&plates_cn=' + this.params.plates_cn
					+ '&baojianr=' + this.params.baojianr
					+ '&cn_planned_industry_name_cn=' + this.params.cn_planned_industry_name_cn
					+ '&hot_status=' + this.params.hot_status
					+ '&applicationdate_begin=' + this.params.applicationdate_begin
					+ '&applicationdate_end=' + this.params.applicationdate_end
				window.location.href = url;
			},
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
				if (val == 1) {
					if (!this.params.stockname) {
						this.messLoad()
					}
				}
				if (val == 2) {
					if (!this.params.stockcode) {
						this.messLoad()
					}
				}
				if (val == 3) {
					if (!this.params.searchstr) {
						this.messLoad()
					}
				}
            },
			// 老版本导出（新股日历版本）
			handopen(){
				if (this.selectedRows.length > 0) {
					let str = ''
					let arr =[]
					this.selectedRows.map(ev => {
						if(str){
							str += ',' + this.columnsData[ev].iposelling_id
						}else{
							str = this.columnsData[ev].iposelling_id
						}
						arr.push(this.columnsData[ev].iposelling_id)
					})
				
					this.$ajax({
						method: 'post',
						url: this.$api.getstockstables,
						data:{"idList":arr}
					}).then(res => {
						if (res.data.qmiscode == 1000) {
							window.open(this.$api.openurls+ '/png' + '?idlist='+str)
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
				}else{
					this.$message.error('請選擇數據');
				}
			},
			fandfn(val){
				this.params.schedule = ''
				if(val == 'back'){
					this.params.missionflag = 0
					this.params.schedule = ''
					this.params.status_cn=''
				}else{
					this.params.missionflag = 1
					this.params.schedule = val
					this.params.status_cn=val
				}
				this.messionEvent()
			},
			handleChange(info) {
				if (info.file.response) {
					if (info.file.response.qmiscode == 1000) {
						this.loading = true;
						this.$message.success('導入成功');
						this.messLoad();
					} else {
						this.loading = false;
						this.$message.error(info.file.response.qmismsg);
					}
				}
			},
			beforeUpload(file) {
				var fileFormat = file.name
					.substring(file.name.lastIndexOf("."))
					.toLowerCase();
				const isJpgOrPng = fileFormat.match(/.xls|.xlsx/);
				if (!isJpgOrPng) {
					this.$message.error('只能上傳xls或xlsx文件!');
				}
				return isJpgOrPng;
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			handipo(){//ipoAdmin
				if (this.selectedRows.length > 0) {
					let dlist = []
					this.selectedRows.map(ev => {
						dlist.push(this.columnsData[ev].iposelling_id)
					})
					
					this.$ajax({
						method: 'post',
						url: this.$api.ipoAdmin,
						headers: {
							token: this.$store.state.token
						},
						data: {
							"token": this.$store.state.token,
							"aduitList": dlist
						}
					}).then(res => {
						if (res.data.qmiscode === 1000) {
							App.oTool.successT();
							this.selectedRows = []
							this.messLoad();
						} else {
							App.oTool.warningT(res.data.qmismsg);
						}
					})
				} else {
					App.oTool.warningT("請選擇一條數據審批!");
				}
			},
			handDelect() {
				if (this.selectedRows.length > 0) {
					this.$confirm("是否刪除此數據，刪除後不可恢復", "是否刪除？", {
						confirmButtonText: "確認",
						cancelButtonText: "取消",
						confirmButtonClass: "confirmbtn",//自定义class
						type: "warning"
					}).then(() => {
						let dlist = []
						this.selectedRows.map(ev => {
							dlist.push(this.columnsData[ev].iposelling_id)
						})
						
						this.$ajax({
							method: 'post',
							url: this.$api.dropDelete,
							headers: {
								token: this.$store.state.token
							},
							data: {
								"token": this.$store.state.token,
								"idList": dlist
							}
						}).then(res => {
							if (res.data.qmiscode === 1000) {
								App.oTool.successT();
								this.selectedRows = []
								this.messLoad();
							} else {
								App.oTool.warningT(res.data.qmismsg);
							}
						})
						next()
					}).catch(() => {
					})

					
				} else {
					App.oTool.warningT("請選擇一條數據刪除!");
				}
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.applicationdate_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
					this.params.applicationdate_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handland(val) {
				this.$ajax({
					method: 'post',
					url: this.$api.getParamList,
					headers: {
						token: this.$store.state.token
					},
					data: {
						"type": val
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						let obj = []
						res.data.result.map(val => {
							obj.push({
								text: val,
								value: val
							})
						})
						if (val === 'industrys') {
							this.khtypeArrs = obj
						} else if (val === 'baojianr') {
							this.khtypeArrbj = obj
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			downhand(){
				this.dwonopen = false
			},
			handclose(val) {
				this.columnsData.map(ev => {
					for (let key in ev) {
						ev['shShowBol'] = false;
						ev['shKhadmin1Bol'] = false;
						ev['visible_bold'] = false;
					}
				})
				console.log('+++++++++++++++++')
				this.isopen = false
				this.island = false
				console.log(this.island)
				this.isshShowBol = false
				this.itemdata= {}
				// if (val) {
				this.messLoad();
				// }
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getIpoSellingList,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.ipoSellingList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['shShowBol'] = false;
								ev['visible_bold'] = false;
								ev['shKhadmin1Bol'] = false;
							}
						})
						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.stockname || this.params.stockcode || this.params.status_cn || this.params.plates_cn || 
							this.params.baojianr || this.params.cn_planned_industry_name_cn || this.params.searchstr || this.params.hot_status|| this.this.params.applicationdate_begin) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.params.missionflag = 0;
				this.messLoad();
			},
			clearEvent() {
				this.params = {}
				this.params = {
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					searchstr: '',
					hot_status: '',
					perPage: 10, //每頁條目數
					stockname: '', //李百控股    股票名稱
					stockcode: '', //股票代碼
					status_cn: '', //處理中，認購中，待上市，已上市 //上市狀態
					plates_cn: '', //上市板塊
					baojianr: '', //保薦機構
					cn_planned_industry_name_cn: '', //服務業 //上市行業
					applicationdate_begin: '', //認購起始日期
					applicationdate_end: '', //認購截止日期
					timeDate: [],
					missionflag: 0
				}
				this.messLoad();
				this.$router.go(0)
			},
			messionEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			substr(str, a, b) {
				return str.toString().substring(a, b)
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
